import { Component } from '@angular/core';

@Component({
  selector: 'ui-modal-body',
  templateUrl: './modal-body.component.html',
  styleUrls: [ './modal-body.component.less' ],
})
export class UiModalBodyComponent {}
